export { Content } from "./content.component";
